import axiosInstance from '../axiosInstance'

// Models
import { User, UserJson } from '../users/models/user'
import { Notification, NotificationJson } from './models/notification'
import { Site } from '../sites/models/site'
import { Pagination, PaginationDto, paginationFromDto } from '../common/models/pagination'
import { AxiosRequestConfig } from 'axios'

export const show = async (config?: AxiosRequestConfig): Promise<{ user: User }> => {
    const response = await axiosInstance.get('/api/user', config)

    const data = response.data.data as UserJson

    return {
        user: User.fromJson(data)
    }
}

export const update = async (form: { email?: string, contactNumber?: string }): Promise<{ user: User }> => {
    const data: { email?: string, contact_number?: string } = {}

    if (form.email) {
        data.email = form.email
    }

    if (form.contactNumber) {
        data.contact_number = form.contactNumber
    }

    const response = await axiosInstance.post('api/user', data)

    const userJson = response.data.data as UserJson

    return {
        user: User.fromJson(userJson)
    }
}

export const fetchNotifications = async (site: Site, perPage: number, page: number): Promise<{ notifications: Notification[], pagination: Pagination }> => {
    const params = {
        site_id: site.id,
        per_page: perPage,
        page: page,
    }

    const response = await axiosInstance.get('api/user/notifications', { params })

    const data = response.data.data as NotificationJson[]
    const meta = response.data.meta as { pagination: PaginationDto }

    return {
        notifications: data.map((notification) => {
            return Notification.fromJson(notification)
        }),
        pagination: paginationFromDto(meta.pagination)
    }
}

export const logOut = async (config?: AxiosRequestConfig): Promise<void> => {
    await axiosInstance.post('logout', undefined, config)
}